import { API } from '../../shared/constants/constants';
import {
  normalizeTenantAddonControlPayload,
  normalizeTenantCreatePayload,
  normalizeTenantId,
  normalizeTenantUpdatePayload,
} from '../../shared/utils/tenantNormalization';
import { normalizeSetTenantIdPayload, normalizeUserId } from '../../shared/utils/userNormalization';
export const getTenants = async () => {
  try {
    const res = await API.get(
      `tenant/allTenants?getTenantTrackingInformation=true&getAddonControls=true&getTenantOccupiedSeatCount=true`
    );
    if (res.status === 204) {
      return 'noData';
    }
    return res.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const postNewTenant = async (tenant) => {
  const normalized = normalizeTenantCreatePayload(tenant);
  return API.post(`tenant`, normalized);
};

export const switchTenant = async (user, tenant) => {
  try {
    const normalizedId = normalizeUserId(user?.id ?? user?._id);
    const payload = normalizeSetTenantIdPayload({ tenantId: tenant?.id ?? tenant?._id });
    const res = await API.put(`user/tenantId/${normalizedId}`, payload);
    if (res.status !== 201) {
      return { severity: 'error', message: 'Client switch unsuccessful' };
    } else {
      return { severity: 'success', message: 'Client Switch Successful, Please Refresh Page!' };
    }
  } catch (e) {
    return { severity: 'error', message: e.message };
  }
};

export async function updateTenant(tenant, body) {
  const normalizedBody = normalizeTenantUpdatePayload(body);
  const normalizedId = normalizeTenantId(tenant?._id);

  try {
    const res = await API.put(`tenant/${normalizedId}`, normalizedBody);
    return res.data || null;
  } catch (e) {
    return { severity: 'error', message: e.message };
  }
}

export async function updateTenantAddonControl(tenant, addonControl) {
  const normalizedBody = normalizeTenantAddonControlPayload(addonControl);
  const normalizedId = normalizeTenantId(tenant?._id);

  try {
    const res = await API.put(`/tenant/${normalizedId}/addon-control`, normalizedBody);
    return res.data || null;
  } catch (e) {
    return e;
  }
}
